module.exports = __webpack_public_path__ + "static/media/ordercoffee.d33ea13f.png";